export class EventRecord {
    id?: number;
    name: string;
    created: Date;
    level: string;
    message?: string;
    context?: string;
    shiftId?: number;
    vehicleId?: number;
    driverId?: number;
}

export enum EventType {
    SHIFT_AUTO_END_TASK = 'SHIFT_AUTO_END_TASK',
    ROUTES_IMPORT_TASK = 'ROUTES_IMPORT_TASK',
    STATIONARY_ALERT = 'STATIONARY_ALERT',
    ASSIGNMENT_REQUESTED = 'ASSIGNMENT_REQUESTED',
    ASSIGNMENT_DECLINED = 'ASSIGNMENT_DECLINED',
    SHIFT_PAUSED = 'SHIFT_PAUSED',
    SHIFT_RESUMED = 'SHIFT_RESUMED',
    NO_LONGER_STATIONARY = 'NO_LONGER_STATIONARY',
    EMAIL_EVENT = 'EMAIL_EVENT',
}
